import {PatMotivoBaixaModel} from '@/models/patrimonio/patmotivobaixa/patmotivobaixa.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class PatMotivoBaixaService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<PatMotivoBaixaModel>>> {
  return api.post <DataSource <PatMotivoBaixaModel>>('/PatMotivoBaixa/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  });
 }

 inserirAtualizar(patMotivoBaixa: PatMotivoBaixaModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/PatMotivoBaixa', patMotivoBaixa);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/PatMotivoBaixa/' + id);
 }

 atualizar(patMotivoBaixa: PatMotivoBaixaModel): Promise<AxiosResponse> {
  return api.put('/PatMotivoBaixa', patMotivoBaixa);
 }

 async get(id: number): Promise<PatMotivoBaixaModel> {
  const result = await api.get<PatMotivoBaixaModel>(`/PatMotivoBaixa/${id.toString()}`);
  return result.data;
 }

 async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/PatMotivoBaixa/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }
}
export default new PatMotivoBaixaService();
